export const COLORS = {
    trueBlack: '#000000',
    black: '#1c1d28',
    white: '#ffffff',

    background: 'hsl(var(--background-start-rgb))',
    foreground: 'hsl(var(--foreground-rgb))',

    neotaste: '#53F293',
    neotasteDark: '#11301D',

    warning: 'hsl(var(--warning))',
    'warning-foreground': 'hsl(var(--warning-foreground))',

    destructive: 'hsl(var(--destructive))',
    'destructive-foreground': 'hsl(var(--destructive-foreground))',

    blackTransparent100: 'rgba(28, 29, 40, 0)',
    blackTransparent20: 'rgba(28, 29, 40, 0.2)',
    blackTransparent10: 'rgba(28, 29, 40, 0.1)',

    grey: {
        100: '#f0f0f0',
        200: '#e0e0e0',
        300: '#d0d0d0',
        400: '#c0c0c0',
        500: '#b0b0b0',
        600: '#a0a0a0',
        700: '#909090',
        800: '#808080',
        900: '#707070',
    },

    mustard: {
        100: '#fffbc2',
        200: '#fff592',
        300: '#ffe645',
    },
}
